import type { AuditLogEntry } from '../../api';
import { FAKTO_SUPPORT_LABEL } from '../../lib/auditEvents';

/** Who did an audit event: a user's email, the Fakto Support badge, or a since-deleted user. */
export function AuditActor({ log }: { log: AuditLogEntry }) {
  if (log.actor.type === 'fakto_support') {
    return (
      <span className="actor-badge" title="Fakto's support team, working in your organization">
        {FAKTO_SUPPORT_LABEL}
      </span>
    );
  }
  if (log.actor.type === 'deleted_user') {
    return <span className="audit-muted">Deleted user</span>;
  }
  return <span title={log.actor.name ?? undefined}>{log.actor.email}</span>;
}
